<template>
  <div class="cursor-animation-container" v-bind:class="{ hide: !processing }">
  </div>
</template>

<script>
  import Vue from 'vue';
  export default {
    name: 'cursor-spinner',
    props: {
      processing: {
        type: Boolean,
        required: true
      }
    }
  };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="css" scoped>

  .cursor-animation-container {
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    cursor: wait;
    z-index: 19999;
  }

</style>



// WEBPACK FOOTER //
// src/components/widgets/CursorSpinner.vue